import React from "react";
import { Box, Paper, Button } from "@mui/material";
import "./CustomPicker.css";
import dayjs from "dayjs";
import _range from "lodash/range";

const CustomYearPicker = ({ getSelectedYear, positionTop, positionLeft }) => {
  const minYear = dayjs().subtract(9, "year").format("YYYY");
  const maxYear = dayjs().add(15, "year").format("YYYY");
  const yearRange = _range(minYear, maxYear);

  return (
    <Box
      className="yearContainer"
      style={{
        top: "50px",
        left: "-50px",
      }}
    >
      {yearRange.map((year, i) => (
        <Paper key={i} elevation={0} className="yearRange">
          <Button
            className="yearButton"
            value={year}
            onClick={(event) => getSelectedYear(event)}
          >
            {year}
          </Button>
        </Paper>
      ))}
    </Box>
  );
};

export default CustomYearPicker;
